import { useEffect, useState } from "react";
import {Price} from "../models/price";
import http_client from "../net/http_client";

export const useFetchItem = (itemId) => {
  const [item, setItem] = useState(null);
  const [itemPrice, setItemPrice] = useState(new Price(0));

  useEffect(() => {
    let isMounted = true;
    async function fetchData() {
      try {
        const response = await http_client().get(`/api/v1/site/items/${itemId}`);
        if (isMounted) {
          setItem(response.data.item);
          setItemPrice(new Price(response.data.item.render_auction_hope_price));
        }
      } catch (e) {
        console.log(`catch at top: ${e.message}`);
      }
    }
    fetchData();
    return () => {
      isMounted = false;
    }
  }, []);

  return [item, itemPrice];
}
